import { getRootNavComponentDimensionAction } from '../actions';
import { isWindowTopLevel } from './isWindowTopLevel';
export function updateRootnavComponentDimension(compName, dimensions, dispatch) {
  if (!isWindowTopLevel()) {
    if (compName === 'GlobalToolbar' || compName === 'Banners') {
      const payload = {
        compName,
        dimensions: {
          height: 0
        }
      };
      const action = getRootNavComponentDimensionAction(payload);
      dispatch(action);
    }
    return;
  }
  const payload = {
    compName,
    dimensions
  };
  const action = getRootNavComponentDimensionAction(payload);
  dispatch(action);
}